import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import { PARITY_EXPORT_REPORT_EXECUTION_FRAGMENT } from '@app/model/parity/_export/service/ParityExportGraphQLFragments';

export const FIND_COMPANY_HOTEL_PARITY_EXPORT_REPORT_EXECUTION_QUERY: GraphQL = {
	name: 'findCompanyHotelParityExportReportExecution',
	gql: gql`
		${PARITY_EXPORT_REPORT_EXECUTION_FRAGMENT}
		query findCompanyHotelParityExportReportExecution($companyHotelId: Long!, $reportExecutionId: Long!) {
			findCompanyHotelParityExportReportExecution(companyHotelId: $companyHotelId, reportExecutionId: $reportExecutionId) {
				...ParityExportReportExecutionFields
			}
		}
	`
};

export const FIND_COMPANY_HOTEL_PARITY_EXPORT_REPORT_EXECUTIONS_QUERY: GraphQL = {
	name: 'findCompanyHotelParityExportReportExecutions',
	gql: gql`
		${PARITY_EXPORT_REPORT_EXECUTION_FRAGMENT}
		query findCompanyHotelParityExportReportExecutions($companyHotelId: Long!) {
			findCompanyHotelParityExportReportExecutions(companyHotelId: $companyHotelId) {
				...ParityExportReportExecutionFields
			}
		}
	`
};

export const SAVE_PARITY_EXPORT_REPORT_MUTATION: GraphQL = {
	name: 'saveParityExportReport',
	gql: gql`
		${PARITY_EXPORT_REPORT_EXECUTION_FRAGMENT}
		mutation saveParityExportReport($input: ParityExportReportInput!) {
			saveParityExportReport(input: $input) {
				...ParityExportReportExecutionFields
			}
		}
	`
};
